import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSeatSide = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 650,
	height: 500,
	viewBox: "0 0 650 500",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M650 25V137.5H350V0H625C631.63 6.63029e-05 637.989 2.63401 642.678 7.32241C647.366 12.0108 650 18.3696 650 25ZM500 325H650V187.5H500V325ZM200 325H450V187.5H200V325ZM150 187.5H0V325H150V187.5ZM350 500H625C631.63 500 637.989 497.366 642.678 492.678C647.366 487.989 650 481.63 650 475V375H350V500ZM300 0H25C18.3696 6.63029e-05 12.0108 2.63401 7.3224 7.32241C2.63401 12.0108 6.63029e-05 18.3696 0 25V137.5H300V0ZM0 475C6.63029e-05 481.63 2.63401 487.989 7.3224 492.678C12.0108 497.366 18.3696 500 25 500H300V375H0V475Z" })
});
export default SvgSeatSide;
